export default "__VITE_ASSET__DXiV$hkA__"